import preparedReducer from './reducer';
import {
  requestEmployees,
  requestEmployeesOptions,
  createEmployee,
  updateEmployee,
  deleteEmployee,
  updateEmployeeForm,
  getUser,
  updateEmployeeBadge,
  requestEmployeeBadge,
  requestClientEmailSettingsByEmployee,
  requestSiteEmailSettingsByEmployee,
  requestMobilePatrolEmailSettingsByEmployee,
  updateClientEmailSettings,
  updateSiteEmailSettings,
  updateMobilePatrolEmailSettings,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'employees';

export const selectors = (state) => state[SLICE_NAME];
export const selectEmployeeBadge = (id) => (state) => state[SLICE_NAME].badges[id] || {};
export const selectClientEmailSettings = (id) => (state) => state[SLICE_NAME].clientEmailSettings[id] || [];
export const selectSiteEmailSettings = (id) => (state) => state[SLICE_NAME].siteEmailSettings[id] || [];
export const selectMobilePatrolEmailSettings = (id) => (state) => state[SLICE_NAME].mobilePatrolEmailSettings[id] || [];

export const actions = {
  requestEmployees,
  requestEmployeesOptions,
  createEmployee,
  updateEmployee,
  deleteEmployee,
  updateEmployeeForm,
  getUser,
  updateEmployeeBadge,
  requestEmployeeBadge,
  requestClientEmailSettingsByEmployee,
  requestSiteEmailSettingsByEmployee,
  requestMobilePatrolEmailSettingsByEmployee,
  updateClientEmailSettings,
  updateSiteEmailSettings,
  updateMobilePatrolEmailSettings,
};
